import { kuiperClassNames, WithTooltip, Button } from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'
import { containerStyles, buttonStyles } from './styles'
import { Props } from './types'

export const EmptyAccountOptions: React.FC<Props> = ({
  openAccountCreator,
  accountTerm,
  canCreateAccount,
  tooltipText,
  contentText,
}) => {
  const onClick = () => {
    openAccountCreator()
    // Popover remains visible until another outside element is clicked
    // Which is weird because hideOnClick is true for TippyAdapter
    const outsideElement = document.querySelector(
      '.postMetaBucket'
    ) as HTMLElement
    outsideElement.click()
  }
  return (
    <div className={kuiperClassNames('no-options')} css={containerStyles}>
      <p>{contentText}</p>
      <AnalyticsLayer name="Create Account Button">
        <WithTooltip
          className="create-new-from-post"
          disabled={canCreateAccount}
          tooltipOptions={{
            position: 'top',
          }}
          content={tooltipText}
        >
          <Button
            style={buttonStyles}
            disabled={!canCreateAccount}
            label={`Add ${accountTerm}`}
            onClick={onClick}
            size="medium"
          />
        </WithTooltip>
      </AnalyticsLayer>
    </div>
  )
}
